import { put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertCatch } from "../../../common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectRegisteredIpos: "selectRegisteredIpos [Action]",
  selectRegisteredIposLoading: "selectRegisteredIposLoading [Action]",
  selectRegisteredIposAsync: "selectRegisteredIposAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
};

export const selectRegisteredIposReducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectRegisteredIpos:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.selectRegisteredIposLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  //responseData.data.response.error_code
  yield put({
    type: actionTypes.selectRegisteredIposLoading,
    payload: payload,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "ipo",
    method_type: "select_registered_ipos",
    data: payload?.data ? payload.data : {},
  };

  try {
    let res = yield AxiosCustom(config, data);
    // let isOk = handleNotificationAlertTrySelect(res);
    // if (!isOk) {
    // 	return;
    // }
    yield put({
      type: actionTypes.selectRegisteredIpos,
      payload: res?.data?.response,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectRegisteredIposLoading,
      payload: false,
    });
  }
}

export function* selectRegisteredIpos() {
  yield takeLatest(actionTypes.selectRegisteredIposAsync, handleWorker);
}
